import * as Yup from "yup";
import { Formik, Form } from "formik";
import Section from "../common/Details";
import GenericModal from "../../Ui/Modal";
import { Toaster } from "react-hot-toast";
import { JobsApi } from "../../../service";
import Divider from "@mui/material/Divider";
import CircularLoader from "../../Ui/Loader";
import ButtonComponent from "../../Ui/Button";
import FormField from "../../utils/FormFileds";
import useApiHandler from "../../hooks/ApiHandler";
import { headers } from "../../constant/Home/Dashboard";
import { UserContext } from "../../context/UserContext";
import TableScreen from "../common/TableScreen/TableScreen";
import { useStatisticsData } from "../../context/StatisticsData";
import { searchbarVisibilty } from "../../constant/Home/Dashboard";
import React, { useState, useRef, useContext, useEffect } from "react";
import { generatePendingApprovedJob } from "../../constant/Home/Jobs";
import { useCurrentSelectedData } from "../../context/CurrentSelectedDataContext";
import { renderCell } from "../../utils/utils";
const DenialReasonSchema = Yup.object().shape({
  denialReason: Yup.string().trim().required("Denial reason is required"),
});
const MODAL_STATES = {
  JOB_DETAILS: "jobDetails",
  DENIAL_REASON: "denialReason",
};
const PendingApprovals = () => {
  const { userData } = useContext(UserContext);
  const [pendingApprovalSearch, setPendingApprovalSearch] = useState("");
  const [modalState, setModalState] = useState("");
  const { callApi, loading } = useApiHandler();
  const { currentSelectedData, setCurrentSelectedData } =
    useCurrentSelectedData();
  const { refreshStatistics } = useStatisticsData();
  const [pendingApprovals, setPendingApprovals] = React.useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const getPendingApprovals = async (opts = {}) => {
    const { silent } = opts;
    await callApi(
      () => JobsApi.getPendingApprovals(currentPage, resultsPerPage),
      {
        silent,
        onSuccess: (response) => {
          if (response.data) {
            setPendingApprovals(response.data?.results || response.data);
            setTotalCount(response.data?.count || response.data?.length || 0);
            if (!silent) console.log(response.data);
          }
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  };

  // Handle results per page change
  const handleResultsPerPageChange = (newResultsPerPage) => {
    setResultsPerPage(newResultsPerPage);
    setCurrentPage(1); // Reset to first page when changing results per page
  };

  useEffect(() => {
    getPendingApprovals();
  }, [currentPage, resultsPerPage]);

  // Refresh pending approvals list during dashboard polling while this tab is mounted
  useEffect(() => {
    const onPoll = () => {
      getPendingApprovals({ silent: true }).catch(() => {});
    };
    window.addEventListener("dashboard:poll", onPoll);
    return () => window.removeEventListener("dashboard:poll", onPoll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, resultsPerPage]);

  const handleApproveRequest = async (requestId) => {
    await callApi(() => JobsApi.approveMaintenanceRequest(requestId), {
      onSuccess: (response) => {
        setPendingApprovals((prev) =>
          prev.filter((request) => request.id !== requestId)
        );
        setModalState("");
        setCurrentSelectedData(null);
        refreshStatistics();
      },
      onError: (error) => {
        console.log("Error approving request:", error);
      },
      successMessage: "Maintenance request approved successfully!",
    });
  };

  const formikSubmitRef = useRef(null);
  const footer = {
    [MODAL_STATES.JOB_DETAILS]: (
      <div className="flex w-full gap-2 justify-between sm2:flex-row flex-col ">
        <ButtonComponent onClick={() => setModalState("")}>
          Back
        </ButtonComponent>
        <div className="flex sm2:gap-4 gap-2 sm2:flex-row flex-col ">
          <ButtonComponent
            onClick={() => setModalState(MODAL_STATES.DENIAL_REASON)}
          >
            Deny With Reason
          </ButtonComponent>
          <ButtonComponent
            bgColor="#3CAB5C"
            color="#FFFFFF"
            onClick={() => handleApproveRequest(currentSelectedData?.id)}
            disabled={loading}
          >
            Approve Job
          </ButtonComponent>
        </div>
      </div>
    ),
    [MODAL_STATES.DENIAL_REASON]: (
      <div className="flex w-full justify-between p-4">
        <ButtonComponent
          onClick={() => setModalState(MODAL_STATES.JOB_DETAILS)}
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          bgColor="#3CAB5C"
          color="#FFFFFF"
          onClick={() => formikSubmitRef.current && formikSubmitRef.current()} // :point_left: call Formik submit
        >
          Submit to Tenant
        </ButtonComponent>
      </div>
    ),
  };

  const content = {
    [MODAL_STATES.JOB_DETAILS]: (
      <Section sections={generatePendingApprovedJob(currentSelectedData)} />
    ),
    [MODAL_STATES.DENIAL_REASON]: (
      <Formik
        initialValues={{ denialReason: "" }}
        validationSchema={DenialReasonSchema}
        onSubmit={async (values) => {
          await callApi(
            () =>
              JobsApi.denyMaintenanceRequest(
                currentSelectedData?.id,
                values.denialReason
              ),
            {
              onSuccess: (response) => {
                setPendingApprovals((prev) =>
                  prev.filter(
                    (request) => request.id !== currentSelectedData?.id
                  )
                );
                setModalState("");
                setCurrentSelectedData(null);
                refreshStatistics();
              },
              onError: (error) => {
                console.log("Error canceling request:", error);
              },
              successMessage: "Maintenance request canceled successfully!",
            }
          );
        }}
      >
        {({ handleSubmit, submitForm }) => {
          // store reference to submitForm
          formikSubmitRef.current = submitForm;
          return (
            <Form
              onSubmit={handleSubmit}
              className="md:p-4 p-2 flex flex-col gap-4"
            >
              <div className="rounded-[16px] border border-[#ECECEC] flex flex-col md:p-6 p-2 gap-8 max-w-[720px] w-full m-auto">
                <h1 className="md:text-[32px] text-[20px] text-[#242424] text-center font-medium">
                  Why is this request being denied?
                </h1>
                <FormField
                  type="textarea"
                  name="denialReason"
                  label="Let your tenant know why this work order is being denied:"
                  placeholder="Enter here"
                  rows={4}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    ),
  };
  const handleClose = () => {
    setModalState("");
  };
  const filteredRows = React.useMemo(() => {
    if (!pendingApprovalSearch) return pendingApprovals;
    const searchLower = pendingApprovalSearch.toLowerCase();

    return pendingApprovals.filter((row) => {
      return (
        row?.jobNumber?.toLowerCase().includes(searchLower) ||
        row?.propertyAddress?.streetAddress
          ?.toLowerCase()
          .includes(searchLower) ||
        row?.issueType?.toLowerCase().includes(searchLower)
      );
    });
  }, [pendingApprovalSearch, pendingApprovals]);
  return (
    <>
      <Toaster />
      {loading ? (
        <CircularLoader minHeight="400px" />
      ) : pendingApprovals.length === 0 ? (
        <div className="text-center py-8 text-[#595959]">
          <p className="text-[16px] font-[500]">
            No pending approvals at the moment.
          </p>
          <p className="text-[14px] mt-2">
            All tenant repair requests that require your attention will appear
            here.
          </p>
        </div>
      ) : (
        <TableScreen
          title="Pending Approvals"
          description="View all tenant repair requests that require attention"
          placeholder="Search by job number, property address, job title"
          headers={headers.pendingApprovals}
          rows={filteredRows}
          renderCell={(row, header, colIdx) =>
            renderCell(row, header, colIdx, {
              title: "Job Details",
              setModalState: () => setModalState(MODAL_STATES.JOB_DETAILS),
              setCurrentSelectedData: () => setCurrentSelectedData(row),
              handleApproveRequest: () => handleApproveRequest(row.id),
            })
          }
          onSearch={setPendingApprovalSearch}
          search={searchbarVisibilty[userData.accountType]?.pendingApprovals}
          // Pagination props
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          resultsPerPage={resultsPerPage}
          onResultsPerPageChange={handleResultsPerPageChange}
          totalCount={totalCount}
          useExternalPagination={true}
        />
      )}
      <GenericModal
        logoDetail={
          modalState === MODAL_STATES.JOB_CONFIRMED
            ? "You're Booked! Time to Get to Work."
            : modalState === MODAL_STATES.CANCEL_JOB
            ? "Are you sure you would like to cancel this job?"
            : null
        }
        logo={
          modalState === MODAL_STATES.JOB_CONFIRMED ||
          modalState === MODAL_STATES.CANCEL_JOB ||
          (modalState === MODAL_STATES.MANAGE_JOB &&
            userData.accountType === "VENDOR")
        }
        open={Boolean(modalState)}
        onClose={handleClose}
        title="Job Details"
        children={content[modalState]}
        footer={footer[modalState] || null}
        maxWidth="982px"
      />
    </>
  );
};
export default PendingApprovals;
